import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.function.name";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'NiotaClassicDevicesEditForm',
  mixins: [formMixin],
  props: {
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    applications: {
      type: Array,
      required: false,
      default: new Array()
    },
    datasourceType: {
      type: String,
      required: false,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      extraFields: [{
        name: '',
        value: '',
        icon: ''
      }],
      addressObject: {
        address: '',
        coordinates: [null, null]
      },
      isActility: false,
      adrLimits: [{
        id: '0',
        title: 'SF 12 / BW 125 MHz'
      }, {
        id: '1',
        title: 'SF 11 / BW 125 MHz'
      }, {
        id: '2',
        title: 'SF 10 / BW 125 MHz'
      }, {
        id: '3',
        title: 'SF 9 / BW 125 MHz'
      }, {
        id: '4',
        title: 'SF 8 / BW 125 MHz'
      }, {
        id: '5',
        title: 'SF 7 / BW 125 MHz'
      }, {
        id: '6',
        title: 'SF 7 / BW 250 MHz'
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    buttons: function buttons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        type: 'submit',
        valid: this.isIotHubManager
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    coordinateLookup: function coordinateLookup() {
      return get(this.formItem, 'properties.coordinateMode') !== 'manual';
    }
  }),
  watch: {},
  created: function created() {
    this.formItem = cloneDeep(this.editedItem);

    if (get(this.formItem, 'properties.extraFields') && get(this.formItem, 'properties.extraFields').length) {
      this.extraFields = get(this.formItem, 'properties.extraFields');
    }

    this.setAddressObject();

    if (this.datasourceType === 'actility' || this.datasourceType === 'ACTILITY') {
      this.isActility = true;
    }
  },
  methods: {
    revalidateForm: function revalidateForm() {
      this.$refs && this.$refs.form ? this.$refs.form.validate() : null;
    },
    validateDeviceProperties: function validateDeviceProperties(index, value) {
      var fields = this.extraFields[index] || {};
      var totalLength = [fields.icon || '', fields.name || '', fields.value || ''].join('').length;
      return Boolean(totalLength && value || !totalLength && !value);
    },
    filterItems: function filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    tagsChanged: function tagsChanged(tags) {
      this.formItem.tags = tags;
    },
    addKeyValuePair: function addKeyValuePair() {
      this.extraFields = cloneDeep(this.extraFields.concat([{
        name: '',
        value: '',
        icon: ''
      }]));
    },
    removeKeyValuePair: function removeKeyValuePair(index) {
      pullAt(this.extraFields, [index]);

      if (this.extraFields.length === 0) {
        this.addKeyValuePair();
      } // trigger a UI refresh


      this.extraFields = cloneDeep(this.extraFields);
    },
    updateFormData: function updateFormData(item, value) {
      set(this.formItem, item, value);
    },
    update: function update() {
      if (this.extraFields[0].name && this.extraFields[0].value) {
        if (this.formItem.properties) {
          this.formItem.properties['extraFields'] = this.extraFields;
        } else {
          this.formItem.properties = {};
          this.formItem.properties['extraFields'] = this.extraFields;
        }
      }

      this.updateDevice();
    },
    updateDevice: function updateDevice() {
      var _this = this;

      NiotaClassicApiService.deviceUpdate(this.formItem.id, this.formItem).then(function (res) {
        if (!res.data.err) {
          _this.formItem = res.data.device;

          _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.updateSuccessful'), 'success');

          _this.$emit('refreshList');

          _this.$emit('close');
        } else {
          _this.$snack(res.data.err, 'error');
        }
      }).catch(function (error) {
        if (get(error, 'response.data.err')) {
          _this.$snack(get(error, 'response.data.err'), 'error');
        } else {
          _this.$snack(_this.$i18n_t('NiotaClassic.Devices.snacks.updateFailed'), 'error');
        }
      });
    },
    setAddressObject: function setAddressObject() {
      if (!isNaN(this.formItem.lon) && !isNaN(this.formItem.lat)) {
        this.addressObject = {
          address: this.formItem.deviceAddress,
          coordinates: [this.formItem.lon || null, this.formItem.lat || null]
        };
      }
    },
    addressSelected: function addressSelected(addressData) {
      this.formItem.deviceAddress = addressData.address;

      var _addressData$coordina = _slicedToArray(addressData.coordinates, 2);

      this.formItem.lon = _addressData$coordina[0];
      this.formItem.lat = _addressData$coordina[1];
      this.formItem.properties = _objectSpread(_objectSpread({}, this.formItem.properties || {}), {}, {
        coordinateMode: addressData.pickedManualCoordinates ? 'manual' : 'auto'
      });
    },
    showPrompt: function showPrompt() {
      this.deletePrompt = true;
    }
  }
};